import ajax from "@/lib/ajax";

// 查询患者宣教计划
export async function GetPatientEducationPlanList(payload: any) {
    let res = await ajax.post(`/api/services/app/PDPatientEducationPlanIndex/QueryPatientEducationPlanList`, payload);
    return res.data.result;
}

/**
 * 删除患者宣教计划
 * @param id 
 */
export async function PatientEducationPlanDelete(id: number) {
    let res = await ajax.delete(`/api/services/app/PDPatientEducationPlanIndex/DeletePatientEducationPlan?id=` + id);
    return res.data.result;
}

/**
 * 读宣教步骤
 * @param payload 
 */
export async function getPlanStepList(payload: any) {
    let res = await ajax.post('/api/services/app/PDPatientEducationPlanIndex/QueryPatientEducationPlanStepList', payload)
    return res.data.result
}

/**
 * 读宣教步骤材料
 * @param payload 
 */
export async function getPlanStepDetailList(payload: any) {
    let res = await ajax.post('/api/services/app/PDPatientEducationPlanIndex/QueryPatientEducationPlanStepDetailList', payload)
    return res.data.result
}

/**
 * 宣教步骤完成
 * @param payload
 */
export async function UpdatePatientEducationPlanDetail(payload: any) {
    let res = await ajax.put(`/api/services/app/PDPatientEducationPlanIndex/UpdatePatientEducationPlanDetail`, payload);
    return res.data.result;
}

// 查询患者宣教计划评估
export async function QueryEducationPlanAssess(payload: any) {
    let res = await ajax.post(`/api/services/app/PDPatientEducationPlanIndex/QueryEducationPlanAssess`, payload);
    return res.data.result;
}

/**
 * 新增宣教计划评估
 * @param payload 
 */
export async function InsertEducationPlanAssess(payload: any) {
    let res = await ajax.post(`/api/services/app/PDPatientEducationPlanIndex/InsertEducationPlanAssess`, payload);
    return res.data.result;
}

/**
 * 修改宣教计划评估 
 * @param payload
 */
export async function UpdateEducationPlanAssess(payload: any) {
    let res = await ajax.put(`/api/services/app/PDPatientEducationPlanIndex/UpdateEducationPlanAssess`, payload);
    return res.data.result;
}   

/**
 * 新增患者宣教计划
 * @param payload
 */
export async function SavePatientEducationPlan(payload: any) {
    let res = await ajax.post(`/api/services/app/PDPatientEducationPlanIndex/SavePatientEducationPlan`, payload);
    return res.data.result;
}

/**
 * 读取宣教计划信息
 * @param payload 宣教材料信息查询条件
 */
export async function QueryEducationPlanList(payload: any) {
    let res = await ajax.get(`/api/services/app/PDPatientEducationPlanIndex/GetEducationPlanList`,{params:payload} );
    return res.data.result;
}


export async function DiagnoseList(){ 
	let res = await ajax.post('/api/services/app/PDPatientEducationPlanIndex/DiagnoseList')
	return res.data.result
}


// WEBPACK FOOTER //
// ./src/api/pdEducationPlan/pdPatientEducationPlan/index.ts